import product from '@/api/product';
import user from '@/api/user';
import order from '@/api/order';
import aboutour from '@/api/aboutour';

export default
{
    product,
    user,
    order,
    aboutour
}